<div class="position-fixed bottom-0 end-0 p-3 d-flex flex-column toast-container">
  @for (toast of toastService.toasts(); track toast) {
    <div
      class="toast-div d-flex flex-column mb-3 toast-animation"
      [class.toast-div-prominent]="toast.isProminent"
      [attr.role]="toast.type === ToastType.ERROR ? 'alert' : 'status'"
      aria-atomic="true"
    >
      <div class="d-flex justify-content-between align-items-center header-div">
        <div class="d-flex flex-nowrap align-items-center ps-2">
          <div
            class="result-div"
            [class.bg-success]="toast.type === ToastType.SUCCESS"
            [class.bg-danger]="toast.type === ToastType.ERROR"
          ></div>
          <span
            class="ms-2"
            [class.text-success]="toast.type === ToastType.SUCCESS"
            [class.text-danger]="toast.type === ToastType.ERROR"
          >
            {{ toast.type === ToastType.SUCCESS ? 'Success' : 'Error' }}
          </span>
        </div>
        <button type="button" (click)="close(toast)" class="empty-btn">
          <app-icon class="close-icon" name="closeCross" width="18" height="18"></app-icon>
        </button>
      </div>
      <div class="div-divider"></div>
      <div class="ps-2 pt-2 body-div">
        <span
          [class.text-success]="toast.type === ToastType.SUCCESS"
          [class.text-danger]="toast.type === ToastType.ERROR"
        >
          {{ toast.message }}
        </span>
      </div>
    </div>
  }
</div>
